import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { GetExtensionDetail_extension_extensionHuntGroup } from '../../queries/generated/GetExtensionDetail';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-extension-hunt-group-detail-left-column',
    styleUrls: ['./extension-hunt-group-detail-left-column.component.scss', '../extension-detail-view.component.scss'],
    templateUrl: './extension-hunt-group-detail-left-column.component.html',
    standalone: false
})
export class ExtensionHuntGroupDetailLeftColumnComponent {
   @Input() extensionHuntGroup: GetExtensionDetail_extension_extensionHuntGroup | null;
}
